import { useAuth } from '../context/AuthContext';
import { getTierMeta } from '../lib/pointsService';

function Header({ onHistoryClick, onSavedClick, onCommunityClick, onProfileClick, onAdminClick, onUpgradeClick, onPointsClick, onBiteFeedClick, onExamClick, onJobsClick, feedUnread, currentTier, currentStreak = 0 }) {
  const { user, isGuest, displayName, isAdmin, signOut, totalPoints, pointsTier } = useAuth();
  const tierMeta = getTierMeta(pointsTier || 'learner');

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="54" height="54" aria-hidden="true">
            <defs>
              <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#0EA5E9"/>
                <stop offset="100%" stopColor="#0369A1"/>
              </linearGradient>
              <linearGradient id="boltGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#FFFFFF"/>
                <stop offset="100%" stopColor="#BAE6FD"/>
              </linearGradient>
              <mask id="biteMask">
                <rect x="0" y="0" width="48" height="48" rx="13" fill="white"/>
                <circle cx="44" cy="4" r="11" fill="black"/>
              </mask>
            </defs>
            <rect x="0" y="0" width="48" height="48" rx="13" fill="url(#logoGrad)" mask="url(#biteMask)"/>
            <rect x="0" y="0" width="48" height="48" rx="13" fill="rgba(255,255,255,0.07)" mask="url(#biteMask)"/>
            <path d="M27 9 L15.5 27 H22.5 L20.5 39 L32.5 21 H25.5 Z" fill="url(#boltGrad)"/>
          </svg>
          <span className="logo-text">BiteLearning</span>
        </div>

        <p className="header-tagline">Bite-sized learning by AI. Learn smart, Learn fast</p>
      </div>

      {/* User bar — top-right */}
      <div className="header-user-bar">
        {(user || isGuest) && (
          <>
            <button className="header-history-btn" onClick={onSavedClick} title="Saved items" aria-label="Saved items" data-tooltip="Saved items">
              ⭐ <span className="header-btn-label">Saved</span>
            </button>
            <button className="header-history-btn" onClick={onHistoryClick} title="Learning history" aria-label="Learning history" data-tooltip="Learning history">
              📚 <span className="header-btn-label">History</span>
            </button>
            {user && (
              <>
                <button className="header-history-btn header-bitefeed-btn" onClick={onBiteFeedClick} title="Bite Feed — daily lessons" aria-label="Bite Feed" data-tooltip="Bite Feed — daily lessons">
                  <span className="header-bitefeed-wrap">
                    📡 <span className="header-btn-label">Bite Feed</span>
                    {feedUnread > 0 && (
                      <span
                        className="header-unread-badge"
                        aria-label={`${feedUnread} new lesson${feedUnread > 1 ? 's' : ''} ready`}
                      >
                        {feedUnread}
                      </span>
                    )}
                  </span>
                </button>
                <button className="header-history-btn header-exam-btn" onClick={onExamClick} title="Bite Exam — exam prep" aria-label="Bite Exam" data-tooltip="Bite Exam — exam prep">
                  🎯 <span className="header-btn-label">Bite Exam</span>
                </button>
                <button className="header-history-btn header-jobs-btn" onClick={onJobsClick} title="Bite Jobs — job search" aria-label="Bite Jobs" data-tooltip="Bite Jobs — find jobs">
                  💼 <span className="header-btn-label">Bite Jobs</span>
                </button>
                <button className="header-history-btn header-community-btn" onClick={onCommunityClick} title="Communities" aria-label="Communities" data-tooltip="Communities">
                  🌐 <span className="header-btn-label">Communities</span>
                </button>
                {isAdmin && (
                  <button className="header-history-btn header-admin-btn" onClick={onAdminClick} title="Admin Dashboard" aria-label="Admin Dashboard" data-tooltip="Admin Dashboard">
                    ⚙️ <span className="header-btn-label">Admin</span>
                  </button>
                )}
              </>
            )}
          </>
        )}

        {user ? (
          <>
            {currentStreak > 0 && (
              <span
                className={`streak-badge ${currentStreak >= 7 ? 'streak-badge--hot' : ''}`}
                title={`${currentStreak}-day learning streak! Keep it up!`}
              >
                🔥 {currentStreak}
              </span>
            )}
            <button
              className="points-badge"
              onClick={onPointsClick}
              title={`${(totalPoints || 0).toLocaleString()} AI Points · ${tierMeta.label} tier`}
              style={{ '--tier-color': tierMeta.color }}
            >
              ⭐ <span className="points-badge-num">{(totalPoints || 0).toLocaleString()}</span>
              <span className="points-badge-tier" style={{ color: tierMeta.color }}>{tierMeta.label}</span>
            </button>
            {currentTier === 'free' && (
              <button className="header-upgrade-btn" onClick={onUpgradeClick} title="Upgrade plan" data-tooltip="Upgrade your plan">
                ⚡ Upgrade
              </button>
            )}
            <button
              className="header-user-name header-profile-btn"
              onClick={onProfileClick}
              title="Edit profile"
              data-tooltip="Edit your profile"
            >
              👤 <span className="header-user-label">{displayName}</span>
            </button>
            <button className="header-signout-btn" onClick={signOut}>Sign Out</button>
          </>
        ) : isGuest ? (
          <>
            <span className="header-user-name header-user-guest">Guest</span>
            <button className="header-signout-btn" onClick={signOut}>Create Account</button>
          </>
        ) : null}
      </div>
    </header>
  );
}

export default Header;
